export const getFetchCostByCategoryWidgetDataThunkFixedCacheKey = (
  widgetId: string,
) => {
  return `postUsersMeOrganisationsCurrentWidgetsCostByCategory-${widgetId}-fixed-cache-key`;
};

export const getFetchWidgetViewDataThunkFixedCacheKey = (widgetId?: string) => {
  return `postUsersMeOrganisationsCurrentResourceExplorerViewsByResourceExplorerViewId-${widgetId}-fixed-cache-key`;
};
